import { actions, initialState } from "./state";

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.CHANGE_PROPS_PAGE_INPUT_PENJUALAN:
      return {
        ...state,
        page_input_penjualan: action.payload,
      };
    case actions.CHANGE_PROPS_PAGE_INPUT_TAGIHAN:
      return {
        ...state,
        page_input_tagihan: action.payload,
      };
    case actions.CHANGE_PROPS_PAGE_INPUT_REKAP_TAGIHAN:
      return {
        ...state,
        page_input_rekap_tagihan: action.payload,
      };
    case actions.CHANGE_PROPS_PAGE_WF_PURCHASE_ORDER:
      return {
        ...state,
        page_wf_purchase_order: action.payload,
      };
    case actions.CHANGE_PROPS_PAGE_WF_MUTASI_ITEM:
      return {
        ...state,
        page_wf_mutasi_item: action.payload,
      };
    case actions.CHANGE_PROPS_PAGE_DETAIL_REKAP_JASMED:
      return {
        ...state,
        page_detail_rekap_jasmed: action.payload,
      };
    case actions.CHANGE_PROPS_PAGE_NERACA_BULAN_DETAIL:
      return {
        ...state,
        page_neraca_bulan_detail: action.payload,
      };
    case actions.CHANGE_PROPS_PAGE_LABA_RUGI_DETAIL:
      return {
        ...state,
        page_laba_rugi_detail: action.payload,
      };
    case actions.CHANGE_PROPS_PAGE_JURNAL_UMUM:
      return {
        ...state,
        page_jurnal_umum: action.payload,
      };
    case actions.CHANGE_ACTIVE_MENU:
      return {
        ...state,
        wrapper_active_menu: action.payload,
      };
    case actions.CHANGE_TABS:
      return {
        ...state,
        wrapper_tabs: action.payload,
      };
    case actions.CHANGE_INSURANCE_BPJS_ID:
      return {
        ...state,
        wrapper_insurance_bpjs_id: action.payload,
      };
    case actions.CHANGE_LOADING:
      return {
        ...state,
        wrapper_loading: action.payload,
      };

    case actions.CHANGE_MINIMIZE:
      return {
        ...state,
        wrapper_minimize: action.payload,
      };
    case actions.CHANGE_ACTIVE_TAB:
      return {
        ...state,
        wrapper_active_tab: action.payload,
      };
    case actions.CHANGE_PAGE_PROPS:
      return {
        ...state,
        wrapper_page_props: action.payload,
      };
    case actions.CHANGE_NOTIFIKASI_LIST:
      return {
        ...state,
        notifikasi_list: action.payload,
      };
    case actions.CHANGE_NOTIFIKASI_COUNT:
      return {
        ...state,
        notifikasi_count: action.payload,
      };
    case actions.RESET_PAGE_PROPS:
      return {
        ...state,
        ...action.payload,
      };
    case actions.CHANGE_PROPS_THEME:
      return {
        ...state,
        theme_list: action.payload,
      };
    default:
      return state;
  }
};
